import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-default-react-imports */
import React, { Fragment } from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UICardGrid from 'UIComponents/card/UICardGrid';
import UICardHeader from 'UIComponents/card/UICardHeader';
import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import { H2 } from 'UIComponents/elements/headings';
import UILogo from 'UIComponents/image/UILogo'; // @ts-expect-error untyped dependency

import MainSectionInner from 'ecosystem-marketplace-core/components/layout/MainSectionInner'; // @ts-expect-error static asset

import blobsImageUrl1x from 'bender-url!../../img/provider-ctas-blob-1x.png'; // @ts-expect-error static asset

import blobsImageUrl2x from 'bender-url!../../img/provider-ctas-blob-2x.png';
import { getAppPartnerSignupUrl, getAssetProviderSignupUrl, getSolutionPartnerSignupUrl } from '../utils/urls';
import HomeSection from './HomeSection';
const StyledHomeSection = styled(HomeSection).withConfig({
  displayName: "ProviderSignupSection__StyledHomeSection",
  componentId: "sc-1241eu7-0"
})(["background-image:url(", ");background-image:image-set( url(", ") 1x,url(", ") 2x );background-position:100% 100%;background-repeat:no-repeat;"], blobsImageUrl1x, blobsImageUrl1x, blobsImageUrl2x);

function CardButton(props = {}) {
  return /*#__PURE__*/_jsx(UIButton, Object.assign({}, props, {
    use: "tertiary"
  }));
}

function CardTitle({
  children
}) {
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(UILogo, {
      className: "display-block m-bottom-3",
      name: "hubspot-wordmark",
      height: 24
    }), children]
  });
}

function Card({
  button,
  description,
  subtitle,
  title
}) {
  return /*#__PURE__*/_jsxs(UICardWrapper, {
    children: [/*#__PURE__*/_jsx(UICardHeader, {
      title: /*#__PURE__*/_jsx(CardTitle, {
        children: title
      })
    }), /*#__PURE__*/_jsxs(UICardSection, {
      children: [/*#__PURE__*/_jsx("span", {
        className: "is--heading-5",
        children: subtitle
      }), /*#__PURE__*/_jsx("p", {
        children: description
      })]
    }), /*#__PURE__*/_jsx(UICardSection, {
      children: button
    })]
  });
}

export default function ProviderSignupSection({
  onTrackInteraction
}) {
  return /*#__PURE__*/_jsx(StyledHomeSection, {
    color: "light",
    "data-test-id": "provider-signup-section",
    children: /*#__PURE__*/_jsxs(MainSectionInner, {
      children: [/*#__PURE__*/_jsx(H2, {
        className: "is--heading-1 text-center m-bottom-13",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceUnified.sections.providerSignup.title"
        })
      }), /*#__PURE__*/_jsxs(UICardGrid, {
        children: [/*#__PURE__*/_jsx(Card, {
          button: /*#__PURE__*/_jsx(CardButton, {
            href: getAssetProviderSignupUrl(),
            onClick: () => onTrackInteraction('click asset provider signup button'),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceUnified.sections.providerSignup.assetMarketplace.buttonText"
            })
          }),
          description: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceUnified.sections.providerSignup.assetMarketplace.description"
          }),
          subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceUnified.sections.providerSignup.assetMarketplace.subtitle"
          }),
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceUnified.sections.providerSignup.assetMarketplace.title"
          })
        }), /*#__PURE__*/_jsx(Card, {
          button: /*#__PURE__*/_jsx(CardButton, {
            href: getAppPartnerSignupUrl(),
            onClick: () => onTrackInteraction('click app developer signup button'),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceUnified.sections.providerSignup.appMarketplace.buttonText"
            })
          }),
          description: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceUnified.sections.providerSignup.appMarketplace.description"
          }),
          subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceUnified.sections.providerSignup.appMarketplace.subtitle"
          }),
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceUnified.sections.providerSignup.appMarketplace.title"
          })
        }), /*#__PURE__*/_jsx(Card, {
          button: /*#__PURE__*/_jsx(CardButton, {
            href: getSolutionPartnerSignupUrl(),
            onClick: () => onTrackInteraction('click solution provider signup button'),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceUnified.sections.providerSignup.solutionsDirectory.buttonText"
            })
          }),
          description: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceUnified.sections.providerSignup.solutionsDirectory.description"
          }),
          subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceUnified.sections.providerSignup.solutionsDirectory.subtitle"
          }),
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceUnified.sections.providerSignup.solutionsDirectory.title"
          })
        })]
      })]
    })
  });
}